import type { AlertVariant } from './Alert.types';

export const baseClasses = 'flex';

export const msgClasses = 'text-sm zappos:body-s';

export const contentWrapperClasses = 'flex flex-col mt-3 mb-3 gap-y-2';

export const iconWrapperClasses = 'flex ml-3 mt-[14px] mb-3 mr-1';

export const dismissWrapperClasses = 'ml-auto p-2';

const commonBorderClasses = 'border-[1.5px] rounded-lg zappos:rounded-[4px]';

export const variantClasses: Record<AlertVariant, string> = {
  error: `bg-alert border-[rgb(192,0,10)] shadow-[0_4px_0_rgb(192,0,10)] zappos:bg-red-50 zappos:border-red-350 zappos:shadow-red-350 ${commonBorderClasses}`,
  info: `bg-info border-[rgb(23,22,108)] shadow-[0_4px_0_rgb(23,22,108)] zappos:bg-blue-50 zappos:border-blue-400 zappos:shadow-blue-400 ${commonBorderClasses}`,
  success: `bg-success border-[rgb(8,138,21)] shadow-[0_4px_0_rgb(8,138,21)] zappos:bg-green-50 zappos:border-green-350 zappos:shadow-green-350 ${commonBorderClasses}`,
  warning: `bg-warning border-[rgb(249,189,25)] shadow-[0_4px_0_rgb(249,189,25)] zappos:border-orange-300 zappos:bg-orange-50 zappos:shadow-orange-300 ${commonBorderClasses}`
};

export const variantIconClasses: Record<AlertVariant, string> = {
  error: `text-[rgb(192,0,10)] zappos:text-red-350`,
  info: `text-[rgb(23,22,108)] zappos:text-blue-400`,
  success: `text-[rgb(8,138,21)] zappos:text-green-350`,
  warning: `text-[rgb(249,189,25)] zappos:text-orange-300`
};
